import React, { useContext } from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import classNames from 'classnames';
import { KibChipTab, KibChipTabs } from '@chewy/kib-chips-react';
import './sub-nav.scss';
import AnalyticsContext from '../../context/AnalyticsContext';
import { ANALYTICS_ACTION_CLICK, ANALYTICS_LABEL_SUFFIX_HEADER } from '../../AnalyticsProvider';
import { usePuppyGuide } from './PuppyGuideContext';

const SubNav = ({
  isSticky,
  t,
  isDisplayed = true,
}: {
  t: TFunction<string>;
  isDisplayed?: boolean;
  isSticky: boolean;
}) => {
  const {
    handleSelectSection,
    refSections,
    stickyHeaderTopOffset,
    selectedSection,
  } = usePuppyGuide();
  const analytics = useContext(AnalyticsContext);

  const itemsClassName = classNames('starter-guide-subnav__items', {
    'starter-guide-subnav__items--sticky': isSticky,
  });
  const subNavClassName = classNames('starter-guide-subnav', {
    'starter-guide-subnav--no-size': !isDisplayed,
  });
  return (
    <div className={subNavClassName} style={{ top: stickyHeaderTopOffset }}>
      <KibChipTabs
        className={itemsClassName}
        aria-label="Floating Sub"
        tabIndex={!isDisplayed ? -1 : 0}
      >
        {refSections.map((item, index) => {
          const isSelected = selectedSection === item;
          const isSelectedClass = `starter-guide-subnav__item--select-${index + 1}`;
          const chipClassName = classNames(
            { [isSelectedClass]: isSelected },
            'starter-guide-subnav__item',
          );
          return (
            <KibChipTab
              key={index}
              href="#"
              className={chipClassName}
              data-testid={`header-chips-item-${index + 1}`}
              aria-hidden={!isDisplayed}
              tabIndex={!isDisplayed ? -1 : 0}
              selected={isSelected}
              onClick={(e) => {
                e.preventDefault();
                analytics.trackStarterGuide(
                  ANALYTICS_ACTION_CLICK,
                  `${t(`puppyGuide.sections.${index}.title`)}${ANALYTICS_LABEL_SUFFIX_HEADER}`,
                );
                handleSelectSection(item);
              }}
            >
              {t(`puppyGuide.sections.${index}.title`)}
            </KibChipTab>
          );
        })}
      </KibChipTabs>
    </div>
  );
};

export default withTranslation()(SubNav);
